/* Loaded synchronously before provider scripts. A transfer owns individual
 * requests through a captured fetch function, never through a shared bypass. */
(function (root, factory) {
  'use strict';
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (root && root.document) root.NLCartTransferFence = api.install(root);
})(typeof window === 'undefined' ? null : window, function () {
  'use strict';
  var KEY = 'nl-cart-transfer-lease-v1', INCOMING = 'nl-same-tab-incoming-v1', LOCK = 'nl-cart-transfer-fence-v1', PREFILL = '/apps/appfleece-globe/checkout-prefill', ID = /^[a-f0-9]{64}$/;
  function parseFragment(hash) {
    if (!/^#nl-transfer=/.test(hash || '')) return null;
    var match = /^#nl-transfer=([a-f0-9]{64})\.(?:([a-f0-9]{64})\.(target|finish)|(source))$/.exec(hash);
    if (!match) throw new Error('Invalid transfer link');
    return { id: match[1], key: match[2] || null, phase: match[3] || match[4] };
  }
  function incomingMetadata(value) {
    var result = { id: value.id, key: value.key, phase: value.phase };
    if (value.copyAttempted === true) result.copyAttempted = true;
    if (ID.test(value.fingerprint || '')) result.fingerprint = value.fingerprint;
    if (Number.isFinite(value.expiresAt)) result.expiresAt = value.expiresAt;
    return result;
  }
  function isWriter(input, options, origin) {
    var url = new URL(typeof input === 'string' || input instanceof URL ? input : input.url, origin);
    var method = String(options && options.method || input && input.method || 'GET').toUpperCase();
    return url.origin === origin && (method === 'POST' && url.pathname === PREFILL || method !== 'GET' && method !== 'HEAD' && /\/(?:cart(?:\/(?:add|change|update|clear))?(?:\.js)?|checkout)(?:\/|$)/.test(url.pathname));
  }
  function install(win) {
    var originalFetch = win.fetch.bind(win), incoming = null, failed = false, temporaryBusy = false, ownerDepth = 0;
    var originalXHR = win.XMLHttpRequest && win.XMLHttpRequest.prototype;
    function lease() {
      try {
        var value = win.localStorage.getItem(KEY);
        if (!value) return null;
        var parsed = JSON.parse(value);
        if (!parsed || !ID.test(parsed.id) || !Number.isFinite(parsed.expiresAt) || Object.keys(parsed).sort().join(',') !== 'expiresAt,id') throw new Error('Invalid lease');
        return parsed;
      } catch (_) { failed = true; return { id: null, expiresAt: 0 }; }
    }
    function usable() {
      var test = KEY + '-probe';
      win.localStorage.setItem(test, '1');
      if (win.localStorage.getItem(test) !== '1') throw new Error('Transfer storage unavailable');
      win.localStorage.removeItem(test);
    }
    function busy() { return failed || temporaryBusy || !!lease(); }
    function locks() {
      if (!win.navigator || !win.navigator.locks || typeof win.navigator.locks.request !== 'function') throw new Error('Basket writer lock unavailable');
      return win.navigator.locks;
    }
    async function withLock(work) {
      var abort = new win.AbortController();
      var timer = win.setTimeout(function () { abort.abort(); }, 8000);
      try {
        return await locks().request(LOCK, { mode: 'exclusive', signal: abort.signal }, async function () {
          win.clearTimeout(timer); ownerDepth += 1;
          try { return await work(); } finally { ownerDepth -= 1; }
        });
      } finally { win.clearTimeout(timer); }
    }
    async function ordinaryWriter(work) {
      if (busy()) throw new Error('Basket transfer pending');
      // Older browsers can keep shopping; the handoff itself still requires locks.
      if (!win.navigator || !win.navigator.locks || typeof win.navigator.locks.request !== 'function') return work();
      return locks().request(LOCK, { mode: 'exclusive' }, function () {
        if (busy()) throw new Error('Basket transfer pending');
        return work();
      });
    }
    function display(error) {
      if (!win.document.documentElement) return;
      win.document.documentElement.setAttribute('data-nl-transfer-busy', error ? 'error' : 'loading');
      var style = win.document.getElementById('nl-cart-transfer-status');
      if (!style) {
        style = win.document.createElement('style'); style.id = 'nl-cart-transfer-status';
        (win.document.head || win.document.documentElement).appendChild(style);
      }
      var lang = (win.document.documentElement.lang || 'cs').slice(0, 2);
      var copy = error ? { cs: 'Naturlabs: košík je uložený. Převod se nepodařilo ověřit. Neopakujte nákup a vraťte se do původní jazykové verze.', en: 'Naturlabs: your basket is saved. The transfer could not be verified. Return to the original language before continuing.', de: 'Naturlabs: Ihr Warenkorb ist gespeichert. Die Übertragung konnte nicht bestätigt werden. Kehren Sie zur ursprünglichen Sprache zurück.' } : { cs: 'Naturlabs: připravujeme váš košík…', en: 'Naturlabs: preparing your basket…', de: 'Naturlabs: Ihr Warenkorb wird vorbereitet…' };
      style.textContent = 'html[data-nl-transfer-busy] body{visibility:hidden!important}html[data-nl-transfer-busy]::before{content:' + JSON.stringify(copy[lang] || copy.cs) + ';position:fixed;inset:0;display:grid;place-content:center;padding:32px;background:#fff;color:#173f35;font:18px/1.5 sans-serif;z-index:2147483647}';
    }
    function claim(id, expiresAt) {
      if (!ownerDepth) throw new Error('Transfer lease requires the writer lock');
      if (!ID.test(id) || !Number.isFinite(expiresAt) || expiresAt <= Date.now() || expiresAt > Date.now() + 185000) throw new Error('Invalid transfer lease');
      usable(); var current = lease();
      if (failed || current && current.id !== id) throw new Error('Another basket transfer is pending');
      win.localStorage.setItem(KEY, JSON.stringify({ id: id, expiresAt: expiresAt }));
      var actual = lease();
      if (!actual || actual.id !== id || actual.expiresAt !== expiresAt) throw new Error('Transfer lease changed');
      temporaryBusy = false; display(false);
    }
    function quarantine(id, expiresAt) {
      if (!ownerDepth || !ID.test(id) || !Number.isFinite(expiresAt)) throw new Error('Transfer quarantine requires the writer lock');
      usable(); var current = lease();
      if (failed || current && current.id !== id) throw new Error('Another basket transfer is pending');
      win.localStorage.setItem(KEY, JSON.stringify({ id: id, expiresAt: Math.min(expiresAt, Date.now()) }));
      temporaryBusy = true; display(true);
    }
    function alive(id) { var current = lease(); return !failed && !!current && current.id === id && current.expiresAt > Date.now(); }
    function release(id) {
      if (!ownerDepth) throw new Error('Transfer lease requires the writer lock');
      var current = lease(); if (!current || current.id !== id) throw new Error('Transfer lease changed');
      win.localStorage.removeItem(KEY); temporaryBusy = false; win.document.documentElement.removeAttribute('data-nl-transfer-busy');
    }
    function ownerFetch(id, input, options) {
      if (!ownerDepth || !alive(id)) return Promise.reject(new Error('Transfer receipt or lease expired'));
      var url = new URL(typeof input === 'string' || input instanceof URL ? input : input.url, win.location.origin);
      var method = String(options && options.method || input && input.method || 'GET').toUpperCase();
      var allowedProxy = method === 'POST' && url.pathname === PREFILL;
      if (url.origin !== win.location.origin || !(allowedProxy || /\/(?:cart(?:\/(?:add|change|update|clear))?(?:\.js)?)(?:\/|$)/.test(url.pathname)) || url.search || url.hash) return Promise.reject(new Error('Owner request is outside the cart'));
      return originalFetch(input, options);
    }
    // Persist incoming exchange material synchronously BEFORE scrubbing the
    // fragment. Bootstrap never changes a durable lease without the writer lock.
    if (/^#nl-transfer=/.test(win.location.hash || '')) {
      var captured = win.location.hash;
      temporaryBusy = true;
      try {
        incoming = parseFragment(captured);
        var saved = win.sessionStorage.getItem(INCOMING);
        var cached = saved ? JSON.parse(saved) : null;
        if (cached && cached.id === incoming.id) incoming = Object.assign({}, cached, incoming);
        incoming = incomingMetadata(incoming);
        win.sessionStorage.setItem(INCOMING, JSON.stringify(incoming));
        if (win.sessionStorage.getItem(INCOMING) !== JSON.stringify(incoming)) throw new Error('Transfer recovery storage unavailable');
      } catch (_) { incoming = { invalid: true }; failed = true; }
      win.history.replaceState(win.history.state, '', win.location.pathname + win.location.search);
      captured = null; display(failed);
    } else if (busy()) {
      try {
        var pending = win.sessionStorage.getItem(INCOMING);
        if (pending) { incoming = incomingMetadata(JSON.parse(pending)); win.sessionStorage.setItem(INCOMING, JSON.stringify(incoming)); temporaryBusy = true; }
      } catch (_) { failed = true; }
      display(failed);
    }
    win.fetch = function (input, options) {
      if (isWriter(input, options, win.location.origin)) return ordinaryWriter(function () { return originalFetch(input, options); });
      return originalFetch(input, options);
    };
    if (originalXHR) {
      var open = originalXHR.open, send = originalXHR.send, abortXHR = originalXHR.abort;
      var requests = new WeakMap();
      originalXHR.open = function (method, url, async) { requests.set(this, { method: method, url: url, async: async !== false, aborted: false }); return open.apply(this, arguments); };
      if (abortXHR) originalXHR.abort = function () { var request = requests.get(this); if (request) request.aborted = true; return abortXHR.apply(this, arguments); };
      originalXHR.send = function () {
        var request = requests.get(this), xhr = this, args = arguments;
        if (!request || !isWriter(request.url, { method: request.method }, win.location.origin)) return send.apply(xhr, args);
        if (busy() || !request.async) throw new Error('Basket transfer pending or synchronous writer unsupported');
        // XMLHttpRequest.send stays synchronous in interface. Its actual async
        // transport starts only while holding the writer lock, held to loadend.
        ordinaryWriter(function () {
          if (request.aborted) return;
          return new Promise(function (resolve, reject) {
            function done() { xhr.removeEventListener('loadend', done); resolve(); }
            xhr.addEventListener('loadend', done, { once: true });
            try { send.apply(xhr, args); } catch (error) { xhr.removeEventListener('loadend', done); reject(error); }
          });
        }).catch(function () {
          if (request.aborted) return;
          if (typeof win.ProgressEvent === 'function') {
            xhr.dispatchEvent(new win.ProgressEvent('error'));
            xhr.dispatchEvent(new win.ProgressEvent('loadend'));
          }
        });
      };
    }
    function blockedForm(form, submitter) {
      if (!busy() || !form) return false;
      var action = submitter && submitter.formAction || form.action || win.location.href;
      var checkout = submitter && (submitter.name === 'checkout' || submitter.matches && submitter.matches('[name="checkout"],[data-cart-checkout]'));
      return !!checkout || /\/checkouts?(?:\/|$)/.test(new URL(action, win.location.origin).pathname) || isWriter(action, { method: form.method || 'POST' }, win.location.origin);
    }
    win.document.addEventListener('submit', function (event) { if (blockedForm(event.target, event.submitter)) { event.preventDefault(); event.stopImmediatePropagation(); } }, true);
    win.document.addEventListener('click', function (event) {
      var link = event.target.closest && event.target.closest('a[href]');
      if (busy() && link && /\/checkouts?(?:\/|$)/.test(new URL(link.href, win.location.origin).pathname)) { event.preventDefault(); event.stopImmediatePropagation(); }
    }, true);
    if (win.HTMLFormElement) {
      var proto = win.HTMLFormElement.prototype, submit = proto.submit, requestSubmit = proto.requestSubmit;
      proto.submit = function () { if (blockedForm(this)) throw new Error('Basket transfer pending'); return submit.apply(this, arguments); };
      if (requestSubmit) proto.requestSubmit = function (submitter) { if (blockedForm(this, submitter)) throw new Error('Basket transfer pending'); return requestSubmit.apply(this, arguments); };
    }
    win.addEventListener('storage', function (event) { if (event.key === KEY) { if (busy()) display(false); else win.document.documentElement.removeAttribute('data-nl-transfer-busy'); } });
    return { claim: claim, release: release, alive: alive, ownerFetch: ownerFetch, withLock: withLock, quarantine: quarantine, incoming: function () { return incoming; }, busy: busy, usable: usable, showError: function () { temporaryBusy = true; display(true); } };
  }
  return { parseFragment: parseFragment, incomingMetadata: incomingMetadata, isWriter: isWriter, install: install, leaseKey: KEY, incomingKey: INCOMING, lockName: LOCK };
});
